export default __webpack_public_path__ + "static/media/1054.d8c4c15d.svg";